import { useFormik } from "formik";
import { useState } from "react";
import DateTimePicker from "react-datetime-picker";
import i18n from "../../../../i18n";

import BoardTextInput from "../../../../components/inputs/dashboardTextInput";
import BoardButton from "../../../../components/buttons/boardButton";
import LinearCalendarIcon from "../../../../icons/linearCalendarIcon";
import { mode, primaryColor } from "../../../../utils";

const AddOffer = ({ t }) => {
  const [startDateValue, setStartDateValue] = useState(new Date());
  const [endDateValue, setEndDateValue] = useState(new Date());

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      rate: "",
    },
    onSubmit: (values) => {
      const payload = {
        ...values,
        startDate: startDateValue,
        endDate: endDateValue,
      };
      console.log("Submitting Offer:", payload);
    },
  });

  const handleCancel = () => {
    formik.resetForm();
  };

  const formatDate = (date) =>
    date.toLocaleDateString(i18n.language === "ar" ? "ar-EG" : "en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

  return (
    <form onSubmit={formik.handleSubmit} className="text-black dark:text-white">
      <BoardTextInput formik={formik} label={t("offerName")} name="name" />

      <BoardTextInput
        formik={formik}
        label={t("briefDescription")}
        name="description"
      />

      <BoardTextInput formik={formik} label={t("discountRate")} name="rate" />

      <section className="flex flex-wrap items-center gap-4 my-5 md:flex-nowrap">
        <div className="p-4 rounded-xl bg-[#F3F4F6] dark:bg-[#1F2937] min-w-[200px]">
          <div className="flex items-center gap-2">
            <DateTimePicker
              format=" "
              disableClock
              onChange={setStartDateValue}
              value={startDateValue}
              calendarIcon={
                <LinearCalendarIcon stroke={mode === "dark" ? "white" : ""} />
              }
              clearIcon={null}
            />
            <span>{t("startDate")}</span>
          </div>
          <h3 className="text-end dark:text-white" style={{ color: primaryColor }}>
            {formatDate(startDateValue)}
          </h3>
        </div>

        <div className="p-4 rounded-xl bg-[#F3F4F6] dark:bg-[#1F2937] min-w-[200px]">
          <div className="flex items-center gap-2">
            <DateTimePicker
              format=" "
              disableClock
              onChange={setEndDateValue}
              value={endDateValue}
              calendarIcon={
                <LinearCalendarIcon stroke={mode === "dark" ? "white" : ""} />
              }
              clearIcon={null}
            />
            <span>{t("endDate")}</span>
          </div>
          <h3 className="text-end dark:text-white" style={{ color: primaryColor }}>
            {formatDate(endDateValue)}
          </h3>
        </div>
      </section>

      <div className="flex flex-wrap mx-auto items-center md:flex-nowrap max-w-[600px] gap-4">
        <BoardButton
          type="button"
          onClick={handleCancel}
          secondary
          bg
          className="w-full"
        >
          {t("cancel")}
        </BoardButton>
        <BoardButton type="submit" primary bg className="w-full">
          {t("addOffer")}
        </BoardButton>
      </div>
    </form>
  );
};

export default AddOffer;
